<div class="container">
  <div class="row center">
    <div class="col col-50 white">
      @if (!error) {
        <app-spinner
          [display]="true"
          [class]="'spinner-container'"
          [messageToDisplay]="'Signing you out...'"
        ></app-spinner>
      }
      @if (error) {
        <p role="alert">{{ error }}</p>
      }
      @if (error) {
        <button mat-flat-button (click)="signOut()">Try again</button>
      }
    </div>
  </div>
</div>
